// types.ts
export type AssetType = "image" | "icon" | "video" | "review";

export interface AtomProps {
  bgColor?: string;
  textColor?: string;
  isTagTop?: boolean;
  assetType?: AssetType;
  imageUrl?: string;
  atmc?: string;
  iconUrl?: string;
  iconWidth?: number;
  linkUrl?: string;
  iconHeight?: number;
  subtitle?: string;
  iconClassName?: string;
  mediaHeight?: number; // Added this new optional prop
  videoId?: string;
  title?: string;
  buttonUrl?: string | null;
  buttonText?: string | null;
  buttonVariant?: string | null;
  isLeftAlign?: boolean;
  description?: string;
  tags?: {
    label: string;
  }[];
  className?: string;
  titleClassName?: string;
  descClassName?: string;
  imgSizes?: string;
  colSpan?: number;
}

export const sizeConfig = {
  "1": {
    titleClassName: "text-2xl font-heading pb-3 leading-none",
    descClassName: "text-md",
    imgSizes: "100vw"
  },
  "2": {
    titleClassName: "text-xl font-heading tracking-wide pb-3 leading-none",
    descClassName: "text-md",
    imgSizes: "(max-width: 767px) 100vw,50vw"
  },
  "3": {
    titleClassName: "text-2xl font-heading tracking-wide leading-none pb-3",
    descClassName: "text-md",
    imgSizes: "(max-width: 767px) 100vw, (max-width: 1600px) 30vw, 464px"
  },
  "4": {
    titleClassName: "text-xl font-heading tracking-wide leading-tight pb-3",
    descClassName: "text-sm",
    imgSizes: "(max-width: 767px) 100vw,20vw"
  }
};
